module.exports = __webpack_public_path__ + "assets/img/logo-top40.5751a989.png";